(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trail-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---- Interactive route map (Leaflet + OpenStreetMap), lazy-loaded on scroll ----
  function loadLeaflet(cb) {
    if (window.L) { cb(); return; }
    if (window.__fpLeafletLoading) { window.__fpLeafletLoading.push(cb); return; }
    window.__fpLeafletLoading = [cb];
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    document.head.appendChild(css);
    var js = document.createElement('script');
    js.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    js.onload = function () { (window.__fpLeafletLoading || []).forEach(function (f) { f(); }); window.__fpLeafletLoading = null; };
    document.head.appendChild(js);
  }

  function initMap(el) {
    var dataEl = document.querySelector('[data-fp-map-data="' + el.id + '"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var map = L.map(el, { scrollWheelZoom: false }).setView(data.center, 13);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '© OpenStreetMap contributors'
    }).addTo(map);

    var bounds = [];
    var line = (data.segments || []).map(function (s) { bounds.push([s.lat, s.lng]); return [s.lat, s.lng]; });
    if (line.length > 1) {
      L.polyline(line, { color: '#2f5d3a', weight: 4 }).addTo(map);
    }
    (data.segments || []).forEach(function (s, i) {
      L.circleMarker([s.lat, s.lng], { radius: 5, color: '#23472d', fillColor: '#2f5d3a', fillOpacity: 1 })
        .bindPopup((i + 1) + '. ' + (s.name || 'Segment')).addTo(map);
    });
    (data.pois || []).forEach(function (p) {
      bounds.push([p.lat, p.lng]);
      L.marker([p.lat, p.lng]).bindPopup('<strong>' + (p.name || '') + '</strong>' + (p.type ? '<br>' + p.type.replace(/_/g, ' ') : '')).addTo(map);
    });
    if (bounds.length > 1) { map.fitBounds(bounds, { padding: [30, 30] }); }
  }

  document.querySelectorAll('[data-fp-map]').forEach(function (el) {
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { obs.disconnect(); loadLeaflet(function () { initMap(el); }); }
      });
    }, { rootMargin: '200px' });
    io.observe(el);
  });

  // ---- Elevation profile (SVG area chart from [{mi,ft}] series) ----
  document.querySelectorAll('[data-fp-elev]').forEach(function (fig) {
    var src = fig.querySelector('[data-fp-elev-data]');
    if (!src) return;
    var pts;
    try { pts = JSON.parse(src.textContent); } catch (e) { fig.remove(); return; }
    if (!Array.isArray(pts) || pts.length < 2) { fig.remove(); return; }
    pts = pts.map(function (p) { return { mi: +p.mi, ft: +p.ft }; }).filter(function (p) { return isFinite(p.mi) && isFinite(p.ft); });
    if (pts.length < 2) { fig.remove(); return; }
    var W = 800, H = 200, pad = 28;
    var xs = pts.map(function (p) { return p.mi; }), ys = pts.map(function (p) { return p.ft; });
    var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    var spanX = (maxX - minX) || 1, spanY = (maxY - minY) || 1;
    function sx(v) { return pad + (v - minX) / spanX * (W - pad * 2); }
    function sy(v) { return H - pad - (v - minY) / spanY * (H - pad * 2); }
    var line = pts.map(function (p, i) { return (i ? 'L' : 'M') + sx(p.mi).toFixed(1) + ' ' + sy(p.ft).toFixed(1); }).join(' ');
    var area = line + ' L' + sx(maxX).toFixed(1) + ' ' + (H - pad) + ' L' + sx(minX).toFixed(1) + ' ' + (H - pad) + ' Z';
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('role', 'img');
    svg.innerHTML =
      '<path d="' + area + '" fill="rgba(47,93,58,.15)"></path>' +
      '<path d="' + line + '" fill="none" stroke="#2f5d3a" stroke-width="2.5"></path>' +
      '<text x="' + pad + '" y="14" font-size="11" fill="#5a665c">' + Math.round(maxY) + ' ft</text>' +
      '<text x="' + pad + '" y="' + (H - 6) + '" font-size="11" fill="#5a665c">' + Math.round(minY) + ' ft</text>' +
      '<text x="' + (W - pad) + '" y="' + (H - 6) + '" font-size="11" fill="#5a665c" text-anchor="end">' + maxX + ' mi</text>';
    fig.insertBefore(svg, fig.firstChild);
  });

  // ---- Gallery lightbox (progressive, single shared overlay) ----
  var galleries = document.querySelectorAll('[data-fp-gallery]');
  if (galleries.length) {
    var box = document.createElement('div');
    box.className = 'fp-lightbox';
    box.innerHTML = '<button class="fp-lightbox__close" aria-label="Close">×</button><img alt=""><p class="fp-lightbox__cap"></p>';
    document.body.appendChild(box);
    var boxImg = box.querySelector('img'), boxCap = box.querySelector('.fp-lightbox__cap');
    function close() { box.classList.remove('is-open'); boxImg.src = ''; }
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('fp-lightbox__close')) close(); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') close(); });
    galleries.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var a = e.target.closest('.fp-gallery__item');
        if (!a) return;
        e.preventDefault();
        boxImg.src = a.getAttribute('href');
        boxCap.textContent = a.getAttribute('data-caption') || '';
        box.classList.add('is-open');
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
